(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jungle-arrivals-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mj-arrivals-tabs')) {
  customElements.define('mj-arrivals-tabs', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
        return;
      }
      if (this.initialized || !this.isConnected) return;
      const controls = this.querySelector('.mj-arrivals-tabs__buttons');
      if (!controls) return;
      this.initialized = true;
      const buttons = [...controls.querySelectorAll('button')];
      const cards = [...this.querySelectorAll('[data-arrival-groups]')];
      const empty = this.querySelector('.mj-arrivals-tabs__empty');
      const status = this.querySelector('.mj-arrivals-tabs__status');
      controls.hidden = false;
      const storageKey = 'mj-arrivals:' + this.querySelector('.product-list').id;
      let savedFilter;
      try { savedFilter = sessionStorage.getItem(storageKey); } catch (error) {}

      const select = (button) => {
        let count = 0;
        for (const card of cards) {
          card.hidden = !card.dataset.arrivalGroups.split(' ').includes(button.dataset.arrivalFilter);
          if (!card.hidden) count++;
        }
        for (const item of buttons) item.setAttribute('aria-pressed', String(item === button));
        empty.hidden = count > 0;
        status.textContent = status.dataset.countTemplate.replace('[count]', count).replace('[category]', button.textContent.trim());
      };
      select(buttons.find(button => button.dataset.arrivalFilter === savedFilter) || buttons[0]);
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-arrival-filter]');
        if (button && controls.contains(button)) {
          select(button);
          try { sessionStorage.setItem(storageKey, button.dataset.arrivalFilter); } catch (error) {}
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jungle-split"] && !Shopify.designMode) return;
  try {
    
function jungleFooterMobile() {
  if (!document.body.classList.contains('template-index')) return;
  const mobile = window.matchMedia('(max-width:767px)');
  document.querySelectorAll('.section-footer__menu-block').forEach((block, index) => {
    const title = block.querySelector('.section-footer__title');
    const menu = block.querySelector('ul');
    if (!title || !menu || title.querySelector('button')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mj-footer-toggle';
    button.textContent = title.textContent.trim();
    menu.id = menu.id || 'mj-footer-menu-' + index;
    button.setAttribute('aria-controls', menu.id);
    title.replaceChildren(button);
    const update = () => {
      button.disabled = !mobile.matches;
      button.setAttribute('aria-expanded', String(!mobile.matches));
      menu.hidden = mobile.matches;
    };
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
    });
    mobile.addEventListener('change', update);
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jungleFooterMobile);
else jungleFooterMobile();
document.addEventListener('shopify:section:load', jungleFooterMobile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
